<template>
  <div
    ref="gw_bbox"
    class="gw_bbox"
  >
    <slot
      v-if="sizeSet"
      :height="height"
      :width="width"
    />
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  name: 'GwBoundingBox',
  data() {
    return {
      sizeSet: false,
      width: 0,
      height: 0,
      resizeObserver: null,
    }
  },
  mounted() {
    nextTick(() => this.setSize())
    this.resizeObserver = new ResizeObserver(this.setSize)
    this.resizeObserver.observe(this.$refs.gw_bbox)
  },
  beforeUnmount() {
    this.resizeObserver.unobserve(this.$refs.gw_bbox)
  },
  methods: {
    setSize() {
      if (this.$refs.gw_bbox) {
        const { height, width } = this.$refs.gw_bbox.getBoundingClientRect()
        this.height = height
        this.width = width
        this.sizeSet = true
      }
    },
  },
}
</script>
